import { SetupChart } from "./SetupChart";
import { BuyersTable } from "./BuyersTable";
import { shortDate, qLabel, MIN_BOOK_PCT } from "./srUtil";

const THESIS = {
  playing: ["Working so far", "green"],
  not_yet: ["Not working yet", "red"],
  unclear: ["Too early to tell", "amber"],
};

const plural = (n, w) => `${n} ${w}${n !== 1 ? "s" : ""}`;

export const CurrentSetup = ({ d, onDetail }) => {
  const cur = d.current, [label, cls] = THESIS[cur.chart.thesis] || THESIS.unclear;
  const ql = qLabel(d.quarter), qShort = ql.split(" ")[0];
  const n = cur.buyers.length, k = cur.n_specialists, m = cur.buyers.filter((b) => (b.pct_of_book ?? 0) >= MIN_BOOK_PCT).length;
  return (
    <>
      <section className="card chartfirst fadein" id="performance">
        <div className="charthead">
          <div className="row between"><div>
            <span className="eyebrow">What funds bought · {ql}</span>
            <h3 className={cls} data-testid="sr-thesis-state">{label}</h3>
          </div></div>
          <div className="legend"><span><i></i>Stock price</span><span><i className="basis"></i>Funds’ estimated buy-in price (likely range)</span></div>
        </div>
        <div className="chartwrap"><SetupChart chart={cur.chart} quarterLabel={qShort} /></div>
      </section>
      <section className="section fadein" id="owners">
        <div className="sectionhead">
          <span className="eyebrow">The buyers · click a fund for its track record</span>
          <h2 data-testid="sr-buyers-heading">{plural(n, "fund")} bought. {plural(k, "sector specialist")}, {m} with {MIN_BOOK_PCT}%+ of their portfolio.</h2>
          <p>Sector specialists and funds with {MIN_BOOK_PCT}%+ of their portfolio in it · track records as of {shortDate(cur.skill_as_of, true)}</p>
        </div>
        <BuyersTable cur={cur} sector={d.sector} quarter={qShort} symbol={d.symbol} onDetail={onDetail} />
      </section>
    </>
  );
};
